import { Button, Modal, Table } from "react-bootstrap";

const PriceUpdateModalComponent = ({
  show,
  priceChanges = [],
  unavailableItems = [],
  canConfirm = true,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      className="Re_Order_Modal"
      size="lg"
      backdrop="static"
    >
      <Modal.Header className="p-2" closeButton>
        <span className="fw-bold">Price Update Notice</span>
      </Modal.Header>
      <Modal.Body className="p-2">
        {priceChanges.length > 0 && (
          <>
            <p className="mb-2">
              Some product prices have changed since your original order. Please
              review the updated prices before continuing.
            </p>
            <Table striped bordered size="sm" responsive>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Spec</th>
                  <th className="text-center">Qty</th>
                  <th className="text-end">Original Price</th>
                  <th className="text-end">New Price</th>
                </tr>
              </thead>
              <tbody>
                {priceChanges.map((change, index) => (
                  <tr key={index}>
                    <td>{change.name}</td>
                    <td>{change.attrs}</td>
                    <td className="text-center">{change.quantity}</td>
                    <td className="text-end">
                      $ {Number(change.originalPrice).toFixed(2)}
                    </td>
                    <td
                      className={`text-end fw-bold ${
                        Number(change.newPrice) > Number(change.originalPrice)
                          ? "text-danger"
                          : "text-success"
                      }`}
                    >
                      $ {Number(change.newPrice).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        {unavailableItems.length > 0 && (
          <>
            <p className="mb-2 text-danger">
              The following items are no longer available and will not be added
              to your cart:
            </p>
            <Table bordered size="sm" responsive>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Spec</th>
                  <th className="text-center">Qty</th>
                  <th className="text-end">Status</th>
                </tr>
              </thead>
              <tbody>
                {unavailableItems.map((item, index) => (
                  <tr key={index} className="text-muted">
                    <td>{item.name}</td>
                    <td>{item.attrs}</td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-end fw-bold text-danger">
                      No longer available
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}

        <small className="text-muted">
          {canConfirm
            ? "Confirming will add the available items to your cart at the new prices."
            : "None of these items are currently available, so nothing will be added to your cart."}
        </small>
      </Modal.Body>
      <Modal.Footer className="p-2 d-flex justify-content-between">
        {canConfirm && (
          <Button
            variant="success"
            onClick={onConfirm}
            className="button-shadow"
          >
            Confirm &amp; Continue
          </Button>
        )}
        <Button
          variant="secondary"
          onClick={onCancel}
          className="button-shadow"
        >
          {canConfirm ? "Cancel" : "Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PriceUpdateModalComponent;
